module.exports = __webpack_public_path__ + "media/files/www/privacy_vanity_fair.pdf";